import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/minio';
const endPointV2 = getUrl('backend') + '/api/v2/files';

const getFile = async (fileName, path) => {
  return axios
    .get(endPoint.concat(`/${path}/${fileName}`), {
      responseType: 'blob',
    })
    .then((res) => res);
};

const createFileOnBackend = async (
  file,
  model,
  pid,
  noCheckProvider = true,
) => {
  const headers = {
    file: `newFile.${file.name.split('.').pop().toLowerCase()}`,
  };
  return axios
    .post(
      noCheckProvider
        ? endPointV2.concat(`?model=${model}&onlySave=1`)
        : endPointV2.concat(`?model=${model}&pid=${pid}`),
      file,
      { headers: headers },
    )
    .then((res) => res)
    .catch((error) => {
      throw error;
    });
};

const createFile = async ({ file, model, filename }) => {
  const headers = { 'Content-Type': 'multipart/form-data' };
  var formData = new FormData();
  formData.append('file', file, filename);

  return axios
    .post(endPoint.concat(`/${model}`), formData, {
      headers: headers,
      // timeout: 50000,
    })
    .then((res) => res)
    .catch((error) => {
      throw error;
    });
};

const preprocessFile = async (file, model, pid) => {
  const headers = {
    file: `newFile.${file.name.split('.').pop().toLowerCase()}`,
  };
  return axios
    .post(`${endPointV2}/preprocess?pid=${pid}&model=${model}`, file, {
      headers: headers,
      // timeout: 50000,
    })
    .then((res) => res)
    .catch((error) => {
      throw error;
    });
};

export { createFile, createFileOnBackend, getFile, preprocessFile };
